
import { Component, Mixins, Emit } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import store from '@/store';
import LatestMenu from '@/mixins/LatestMenu';

@Component
export default class GlobalMenu extends Mixins(LatestMenu) {
  private name = 'GlobalMenu';
  
  @Emit()
  private openModalSearchNavi(): void {
    store.commit('searchmodal/open', 'ModalSearchnavi');
  }
}
